import { everestApiRoot } from './root';

export const api = everestApiRoot;
